import {changeRateStore} from '@store/settings/changeRate/change-rate.store';
import {getChangeRateDataSource} from '@store/settings/changeRate/change-rate.requests';

export class ChangeRateQuery {
  store = changeRateStore;

  changeRates$ = getChangeRateDataSource.data$();
}

export const changeRateQuery = new ChangeRateQuery();
